import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: '#459BE9',
        color: '#ffffff',
        borderColor: '#459BE9',
        padding: 25,
        borderRadius: 5,
    },
    rootHovered: {
        backgroundColor: '#459BE9',
        color: '#ffffff',
        borderColor: '#459BE9',
    },
    label: {
        fontWeight: 500,
    },
};

interface IButtonBlueComponentProps {
    text?: string;
    onClick?: (event: any) => void;
    icon?: string;
    disabled?: boolean;
    className?: string;
};

const ButtonBlueComponent = (props: IButtonBlueComponentProps) => {
    return (
        <DefaultButton
            text={props.text}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={styles}
            disabled={props.disabled}
            className={props.className} />
    );
};

export default ButtonBlueComponent;
